var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.209539 7.14926L4.68971 12.6992C5.06048 13.1225 5.6547 13.1628 6.04487 12.8369C6.43505 12.5111 6.49934 11.8525 6.1797 11.4544L2.98948 7.50606L15.0399 7.50606C15.5701 7.50606 16 7.06747 16 6.5266C16 5.98574 15.5701 5.54714 15.0399 5.54714L2.98948 5.54714L6.1797 1.5988C6.49912 1.20096 6.42724 0.551477 6.04487 0.216264C5.65045 -0.129425 5.00915 -0.0440231 4.68971 0.35404L0.209539 5.90394C-0.0822083 6.32227 -0.0572087 6.74401 0.209539 7.14871L0.209539 7.14926Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrowicon);
export default __webpack_public_path__ + "static/media/leftarrowicon.c463cd720511ba94f65e8c0a44892dc4.svg";
export { ForwardRef as ReactComponent };